import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { routeNames } from '../../routes'
import { GuidedSearchQuestionHandler } from '../../containers'
import './GuidedSearchStepContent.sass'

class GuidedSearchStepContent extends Component {
  constructor() {
    super()
    this._startOver = this.startOver.bind(this)
  }

  startOver() {
    this.props.resetAllSteps()
    this.props.setActiveFilterIds([])
  }

  renderResultsSection(matches) {
    return (
      <div className="results-container">
        { matches.relevantCount && !matches.matchesCount ?
          <h1 className="results-count">Relevant Matches</h1> :
          <h1 className="results-count">Tool Matches</h1>
        }

        { matches.relevantCount && !matches.matchesCount ?
          <h1 className="results-count"><span>{matches.relevantCount}</span> of {matches.totalCount}</h1> :
          <h1 className="results-count"><span>{matches.matchesCount}</span> of {matches.totalCount}</h1>
        }

        { matches.relevantCount > 0 || matches.matchesCount > 0 ?
          <Link
            className="btn-blue-transparent"
            to={{
              pathname: routeNames.filteredSearch,
              state: { skipToResults: true }
            }}
          >
            leave guided search and view matches
          </Link>
          :
          [
            <p key={1}>You need more active filters to receive tool matches</p>,
            <button
              key={2}
              className="btn-blue-transparent"
              onClick={this._startOver}
            >
              start over
            </button>
          ]
        }

      </div>
    )
  }

render() {
    const { stepContent, isLastStep, matches } = this.props

    return (
      <div className="guided-search-content">
        <img src={stepContent.icon} alt={`${stepContent.question} icon`}/>
        <h6 className="text-upper">{stepContent.order}. {stepContent.step_title}</h6>
        <h1>{stepContent.question}</h1>
        { stepContent.question_subtext &&
          <p className="question-subtext" dangerouslySetInnerHTML={{__html: stepContent.question_subtext}} />
        }
        { isLastStep ?
          this.renderResultsSection(matches) :
          <div className="questions-container">
            <GuidedSearchQuestionHandler filter={stepContent.filter} />
          </div>
        }
      </div>
    )
  }
}

GuidedSearchStepContent.propTypes = {
  stepContent: PropTypes.object.isRequired,
  isLastStep: PropTypes.bool,
  matches: PropTypes.shape({
    matchesCount: PropTypes.number,
    totalCount: PropTypes.number
  }),
  setActiveFilterIds: PropTypes.func,
  resetAllSteps: PropTypes.func
}

export default GuidedSearchStepContent;
